// React
import PropTypes from "prop-types";
import React, { Children, isValidElement } from "react";
// Framework
import { useTranslate } from "localization";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  DialogActions,
  FormControlLabel,
  Grid,
  makeStyles,
  Skeleton,
  Spacer,
} from "ui";

////////////////////////////////////////////////////
/// Styles
////////////////////////////////////////////////////

const useStyles = makeStyles((theme) => ({
  alert: {
    padding: theme.spacing(0, 1),
  },
}));

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const ModelDialogButtons = ({
  skeleton,
  loading,
  errorCount,
  disableErrorCount,
  keepOpen,
  options,
  onClose,
  onKeepOpen,
  children,
}) => {
  // Styles
  const classes = useStyles();
  // Framework
  const { t } = useTranslate();
  // Render
  return (
    <DialogActions>
      <Grid
        container
        justifyContent="flex-end"
        alignItems="center"
        wrap="nowrap"
        spacing={1}
      >
        {!disableErrorCount && errorCount > 0 && !loading && (
          <Grid item>
            <Alert severity="error" className={classes.alert}>
              {t("core:model.dialog.buttons.error", {
                params: { count: errorCount },
              })}
            </Alert>
          </Grid>
        )}
        <Spacer />
        {options?.keepOpen && (
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  name="keepOpen"
                  checked={keepOpen}
                  onChange={onKeepOpen}
                />
              }
              label={t("core:model.dialog.buttons.keepOpen")}
            />
          </Grid>
        )}
        <Grid item>
          <Box color="action.active">
            <Button
              value="cancel"
              color="inherit"
              variant="contained"
              disabled={loading}
              onClick={onClose}
            >
              {skeleton && loading ? (
                <Skeleton variant="text" width={60} />
              ) : (
                <>{t("core:model.dialog.buttons.cancel")}</>
              )}
            </Button>
          </Box>
        </Grid>
        {Children.map(children, (child, key) => (
          <>
            {isValidElement(child) && (
              <Grid item key={key}>
                {skeleton && loading ? (
                  <Skeleton variant="rect" width={60} height={32} />
                ) : (
                  child
                )}
              </Grid>
            )}
          </>
        ))}
      </Grid>
    </DialogActions>
  );
};

ModelDialogButtons.propTypes = {
  skeleton: PropTypes.bool,
  loading: PropTypes.bool,
  errorCount: PropTypes.number,
  disableErrorCount: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

export default ModelDialogButtons;
